module.exports = __webpack_public_path__ + "img/GrinseKeks.4c8faf19.svg";